export const COMPANY_INFO = {
  legalName: "Общество с ограниченной ответственностью «Арт Далини»",
  address: "Калодищи ул.Тюленина 10",
  unp: "693278376",
  okpo: "510522346000",
  iban: "BY64 BLNB 3012 0001 0357 9200 0933",
  bank: "ОАО «БНБ-Банк», пр-т Независимости, 173, 18 этаж, 220114, Минск, Республика Беларусь",
  swift: "BLNBBY2X",
  email: "pavel_chesnot@mail.ru",
  phone: "+375 33 323 17 00",
  director: "Дедюля А.А.",
};
